<div class="dm-cart-pagamento-gerencia-net-boleto">
  <div class="content">
    Vai ser gerado um boleto com prazo de vecimento <strong>{{vencimentoDias}} dia(s)</strong>.
  </div>  
</div>
<modulo-loader [message]="message" [hidden]="!loader"></modulo-loader>
<modal-info [title]="messageInfo.title" [show]="messageInfo.show" [customClass]="messageInfo.class" [message]="messageInfo.data" (hide)="messageInfo.show=false"></modal-info>

